import { unsafeCoerce } from 'fp-ts/lib/function';

export const makeEndpoint = <Return>(url: string, options?: RequestInit): API3Endpoint<Return> =>
  unsafeCoerce({ url, options: { ...{ method: 'GET' }, ...options } });

export interface API3Endpoint<Return> {
  __resultPhantomData?: Return;
  url: string;
  options: RequestInit;
}
